import React from "react";
import css from "./prod.module.scss";
import { useTranslation } from "react-i18next";
import { useInView, animated } from "@react-spring/web";
import ProdDetail from "./prodDetail/index";
import { useLocation, useNavigate } from "react-router-dom";

const prodList = [
  {
    name: "线上统一支付收银台",
    pic: require("assets/products/paym.png"),
    path: "/prodandsolution/prod/pay",
  },
  {
    name: "POS-MIS",
    pic: require("assets/products/pay2xtransparent.png"),
    path: "/prodandsolution/prod/posmis",
  },
  {
    name: "UPAY",
    pic: require("assets/products/upay2.png"),
    path: "/prodandsolution/prod/upay",
  },
  {
    name: "对账云平台",
    pic: require("assets/products/cloud2x.png"),
    path: "/prodandsolution/prod/cloud",
  },
  {
    name: "分账系统",
    pic: require("assets/products/fz2x.png"),
    path: "/prodandsolution/prod/fz",
  },
  {
    name: "小微云店",
    pic: require("assets/products/xwyd2x.png"),
    path: "/prodandsolution/prod/xwyd",
  },
  {
    name: "银校通",
    pic: require("assets/products/yxt2x.png"),
    path: "/prodandsolution/prod/yxt",
  },
  {
    name: "银医通",
    pic: require("assets/products/yyt2x.png"),
    path: "/prodandsolution/prod/yyt",
  },
];

function Index() {
  const { t } = useTranslation();
  const location = useLocation();
  const paths = location.pathname.split("/");

  return (
    <div style={{ overflow: "hidden" }}>
      {paths.length > 3 ? (
        <ProdDetail prodList={prodList} />
      ) : (
        <div className={css.container}>
          <div className={css.title}>{t("产品中心")}</div>
          <div className={css.prodbox}>
            {prodList.map((item, index) => (
              <Content item={item} key={index}></Content>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const Content = React.memo(({ item, index }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [ref, refStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true }
  );

  return (
    <div ref={ref} onClick={() => navigate(item.path)}>
      <animated.div className={css.prod} key={index} style={refStyle}>
        <div className={css.picbox}>
          <img src={item.pic} alt="" />
        </div>
        <div className={css.name}>{t(item.name)}</div>
      </animated.div>
    </div>
  );
});

export default React.memo(Index);
